import React from 'react'
import {PDFButtons} from './viewer/PdfButtons'
import {formatDate} from '../components/datepicker'
import {dicomDateToDate} from '../lib'
import {en_US} from '..'

const studyDateToDate = (date) => {
  const studyToDate = dicomDateToDate(date)
  return isNaN(studyToDate.getTime()) ? date : formatDate(studyToDate,en_US,"L dd, yyyy")
}

const StudyLine = ({study}) => <React.Fragment>
  <span className="study-title">{study.title}</span> <span>({studyDateToDate(study.date)})</span>
</React.Fragment>

export const Header = {}
class LeftContainer extends React.Component {
  render() {
    const {patientName, studies, readOnly} = this.props
    return (<div className="left-container">
      <h2>Patient: {patientName}</h2>
      <div className="report-studies-list">
        <span>{studies.length > 1 ? "Studies: " : "Study: "}</span>
        {studies.map(study => (
            study.url ?
            <a key={study.url} href={study.url} target="_blank" disabled={readOnly}>
              <span className="icon icon-external-link-line"/>
              <StudyLine study={study}/>
            </a>
            :
            <StudyLine key={study.title+study.date} study={study}/>
        ))}
      </div>
    </div>)
  }
}


Header.LeftContainer = LeftContainer
Header.PDFButtons = PDFButtons


// WEBPACK FOOTER //
// ./~/report-components/src/modules/Header.js